import * as React from "react";
import mapValues from "lodash/mapValues";
import styled from "styled-components";
import DeleteDataLakeAction from "data-lake/data-lake-backend-config/backend-overview/actions/DeleteDataLakeAction";
import { PaginatedList, Spinner, EntityList, EntityListItem } from "components/common";
import DataLakeBackendButton from "data-lake/data-lake-backend-config/DataLakeBackendButton";
import AppConfig from "util/AppConfig";
import { ButtonToolbar, Col, Row } from "components/bootstrap";
import { BACKEND_TYPES } from "archive/ArchiveStore";
import { ConfigurationWell } from "components/configurationforms";
import { DEFAULT_PAGE_SIZES } from "hooks/usePaginationQueryParameter";
import DataLakeBackendActivateButton from "data-lake/data-lake-backend-config/DataLakeBackendActivateButton";
import useDataLakeBackends from "data-lake/data-lake-backend-config/hooks/useDataLakeBackends";
import useDataLakeConfig from "data-lake/configurations/hooks/useDataLakeConfig";
import DataLakeBackendState from "./DataLakeBackendState";
const isCloud = AppConfig.isCloud();
const StyledRow = styled(Row)`
  dt {
    float: left;
    width: 200px;
    overflow: hidden;
    clear: left;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  dd {
    margin-left: 180px;
    display: inline-block;
  }

  dl {
    margin-bottom: 0;
  }
`;
const BackendConfigOverview = () => {
  const { data: backendsList, isInitialLoading: isLoadingBackends } = useDataLakeBackends({ enabled: true });
  const {
    data: dataLakeBackendConfig,
    isSuccess: isCurrentBackendLoaded,
    isInitialLoading: isLoadingDataLakeConfig
  } = useDataLakeConfig();
  if (isLoadingBackends || isLoadingDataLakeConfig) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const formatBackend = (backend) => {
    const { settings, description, id, title } = backend;
    const isActiveBackend = isCurrentBackendLoaded && dataLakeBackendConfig.active_backend === id;
    const actions = !isCloud && /* @__PURE__ */ React.createElement(ButtonToolbar, null, isCurrentBackendLoaded && /* @__PURE__ */ React.createElement(
      DataLakeBackendActivateButton,
      {
        backend,
        isActiveBackend,
        config: dataLakeBackendConfig
      }
    ), /* @__PURE__ */ React.createElement(DataLakeBackendButton, { buttonType: "menuItem", backendId: id }), !isActiveBackend && /* @__PURE__ */ React.createElement(DeleteDataLakeAction, { backend }));
    const normalizedSettings = mapValues(settings, (value, key) => {
      if (key === "type") {
        return BACKEND_TYPES[settings[key]];
      }
      if (key === "aws_secret_access_key" || key === "key") {
        return "***********";
      }
      return value;
    });
    const content = /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(StyledRow, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement(ConfigurationWell, { id, configuration: normalizedSettings })))));
    return /* @__PURE__ */ React.createElement(
      EntityListItem,
      {
        key: `backend-${id || "newbackend"}`,
        title: /* @__PURE__ */ React.createElement(React.Fragment, null, title, " ", /* @__PURE__ */ React.createElement(DataLakeBackendState, { isActiveBackend })),
        description,
        actions,
        contentRow: content
      }
    );
  };
  return /* @__PURE__ */ React.createElement(PaginatedList, { pageSize: DEFAULT_PAGE_SIZES[1], showPageSizeSelect: false, totalItems: backendsList == null ? void 0 : backendsList.length }, /* @__PURE__ */ React.createElement(
    EntityList,
    {
      bsNoItemsStyle: "info",
      noItemsText: "There are no backends to display",
      items: backendsList == null ? void 0 : backendsList.map((backend) => formatBackend(backend))
    }
  ));
};
export default BackendConfigOverview;
